import { render, staticRenderFns } from "./CTTLabel.vue?vue&type=template&id=68e63603&scoped=true"
import script from "./CTTLabel.vue?vue&type=script&lang=js"
export * from "./CTTLabel.vue?vue&type=script&lang=js"
import style0 from "./CTTLabel.vue?vue&type=style&index=0&id=68e63603&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e63603",
  null
  
)

export default component.exports